export function hasLocalStorage() {
  return typeof localStorage !== 'undefined'
}
